/*
 * @Author: leventlei
 * @Date: 2022-02-21 16:42:07
 * @LastEditTime: 2024-10-08 14:14:59
 * @LastEditors: leventlei
 * @Description:
 * @FilePath: /IOT4CMS/src/layouts/index.tsx
 */
import React from 'react'
// import { Redirect } from 'umi'
import SimpleLayout from './simpleLayout'
import BaseLayout from './baseLayout'
import LoginLayout from './loginLayout'

export default function(props: any) {
	// 你可以把它替换成你自己的登录认证规则（比如判断 token 是否存在）
	const isLogin = window.localStorage.getItem('userid')
	// console.log('props pathname:', props)
	const { pathname } = props.location

	// 所有使用简易布局的路由
	let simpleLayoutPathnames: string[] = [
		/// 首页
		'/home',
		'/dashboard',
		'/blocOperatorHome',
		'/businessManagement',
		'/localOperationHome',
		'/propertyManagement',
		'/intelligentInstance',
		/// 空间运营
		'/exhibitionManagement',
		'/exhibitionListManagement',
		'/exhibitionDynamic',
		'/exhibitionOrderManagement',
		'/homestayManagement',
		'/dormitoryListManagement',
		/// 内容运营
		'/miniProgramSetting',
		/// 服务
		'/guestRoomStatus',
		'/orderManagement',
		'/guestRoomReservation',
		'/checkInRegistration',
		'/guestInformation',
		/// 客房
		'/roomTypeManagement',
		/// 智能化
		'/iotInstance',
		'/iotInstanceDetail',
		'/iotProduct',
		'/iotDeviceGroup',
		'/iotDevice',
		'/iotScene',
		'/iotSceneControl',
		/// 物管运营
		'/propertyDevice',
		'/propertyDeviceDetail',
		'/propertyPersonnel',
		'/propertyClean',
		/// 平台设置
		'/projectManagement',
		'/userManagement',
		'/roleManagement',
		'/permissionManagement',
		///
		'/404',
		'/user',
		'/dataOverview',
		'/thirdPartyDataOverview',
		'/dataDetails',
		// 套餐
		'/commodityLibrary',
		'/packageManagement',
		'/packageListManagement',
		/// 运营
		'/operationWindow',
		'/packageOrderManagement',
		'/reservationOrderManagement',
		'/reservationStockManagement',
		/// 风土志会员管理
		'/memberManagement',
		'/memberRightCenter',
	]

	// 所有用到登录注册布局的路由
	let authLayoutPathnames: string[] = [
		'/login',
		'/wechatRelation',
		'/register',
		'/resetPwd',
	]
	if (simpleLayoutPathnames.includes(pathname)) {
		return <BaseLayout>{props.children}</BaseLayout>
	}

	if (authLayoutPathnames.includes(pathname)) {
		return <LoginLayout>{props.children}</LoginLayout>
	}

	// if (pathname === '/') {
	// 	return <SimpleLayout>{props.children}</SimpleLayout>
	// }

	// if (pathname === '/404') {
	// 	return <SimpleLayout>{props.children}</SimpleLayout>
	// }

	// if (!isLogin && pathname !== '/login') {
	// 	return <Redirect to={`/login?timestamp=${new Date().getTime()}`} />
	// }

	return <SimpleLayout>{props.children}</SimpleLayout>

	// return <BaseLayout>{props.children}</BaseLayout>
}
